import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  inject,
  OnDestroy,
} from '@angular/core';
import { formatCountdownTo } from '@app/helpers/formatDateTime.helper';
import type { ICellRendererAngularComp } from 'ag-grid-angular';
import type { ICellRendererParams } from 'ag-grid-community';

export type CountdownCellRow = {
  targetDate: string | null;
  showCountdown: boolean;
};

export type CountdownCellParams = ICellRendererParams<CountdownCellRow>;

@Component({
  selector: 'app-countdown-cell-renderer',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './countdown-cell-renderer.component.html',
  styleUrl: './countdown-cell-renderer.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CountdownCellRendererComponent
  implements ICellRendererAngularComp, OnDestroy
{
  private readonly cdr = inject(ChangeDetectorRef);

  showCountdown = false;
  countdownText = '';
  private intervalId: ReturnType<typeof setInterval> | null = null;
  private targetDate: string | null = null;

  agInit(params: CountdownCellParams): void {
    this.clearInterval();
    const row = params.data;
    this.targetDate = row?.targetDate ?? null;
    this.showCountdown = !!(row?.showCountdown && this.targetDate);
    this.tick();
    if (this.showCountdown) {
      this.intervalId = setInterval(() => {
        this.tick();
        this.cdr.markForCheck();
      }, 1000);
    }
  }

  ngOnDestroy(): void {
    this.clearInterval();
  }

  refresh(): boolean {
    return false;
  }

  private tick(): void {
    this.countdownText = this.targetDate
      ? formatCountdownTo(this.targetDate)
      : '';
  }

  private clearInterval(): void {
    if (this.intervalId !== null) {
      clearInterval(this.intervalId);
      this.intervalId = null;
    }
  }
}
